import { HttpParams } from "@angular/common/http";
import { Node } from "@models/node/Node";

export class NodeParams {
  public getParams(node: Node) {
    let params = new HttpParams();
    if (node.nodeId) {
      params = params.append('nodeId', node.nodeId);
    }
    if (node.filter) {
      params = params.append('filter', node.filter);
    }
    if (node.fileTypeId) {
      params = params.append('fileTypeId', node.fileTypeId);
    }
    if (node.currentPage) {
      params = params.append('currentPage', node.currentPage);
    }
    if (node.sizePage) {
      params = params.append('sizePage', node.sizePage);
    }
    if (node.pageSize) {
      params = params.append('pageSize', node.pageSize);
    }
    if (node.searchId) {
      params = params.append('searchId', node.searchId);
    }
    if (node.active) {
      params = params.append('active', node.active);
    }
    return params;
  }
}
